export const headers = {
  initialHeaders: [
    { title: "Rol", field: "name", child: null },
    { title: "Estado", field: "status", child: null },
  ],
  
};
